import { styled } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as RoleIcon } from '../../../../svg/adminRoleIcon.svg';
import { ReactComponent as Arrow } from '../../../../svg/arrow.svg';
import SettingsModal from '../Modal/settingsCustomModal';
import { convertTimetoString } from '../../../../helperFunction';
import SpecializationOptions from "./SpecializationOptions";
import SpecializationDetails from "./SpecializationDetails";
import UpdateSpecialization from "./UpdateSpecialization";
import DeleteSpecialization from "./DeleteSpecialization";

interface SpecializationResponse {
  StatusCode: number;
  Message: string;
  Data: Specialization[];
}

interface Specialization {
  Id: number;
  SpecializationName: string;
  Score: number;
  IsActive: boolean;
  CreatedBy?: string;
  ModifiedBy?: string;
  CreateDate: string;
  LastModified: string;
  IsDeleted: boolean;
}
interface ComponentProps {
    specialization: SpecializationResponse | undefined;
}

const SpecializationContent: React.FC<ComponentProps> = ({ specialization }) => {
    const [specializationName, setSpecializationName] = useState('');
    const [id, setId] = useState(0);
    const [isActive, setIsActive] = useState(true);
    const [createDate, setCreatedDate] = useState('');
    const [score, setScore] = useState(0);
    const [openSpecializationDetails, setOpenSpecializationDetails] = useState(false);
    const [openUpdateSpecializationModal, setOpenUpdateSpecializationModal] = useState(false);
    const [openDeleteSpecializationModal, setOpenDeleteSpecializationModal] = useState(false);

    const handleOpenSpecializationDetails = () => setOpenSpecializationDetails(true);
    const handleCloseSpecializationDetails = () => setOpenSpecializationDetails(false);

    const handleOpenUpdateSpecializationModal = () => setOpenUpdateSpecializationModal(true);
    const handleCloseUpdateSpecializationModal = () => setOpenUpdateSpecializationModal(false);

    const handleOpenDeleteSpecializationModal = () => setOpenDeleteSpecializationModal(true);
    const handleCloseDeleteSpecializationModal = () => setOpenDeleteSpecializationModal(false);

    function convertDate(dateString: string){
        if(!dateString) return;
        let p = dateString?.split(/\D/g)
        return [p[0], p[1], p[2]].join("-");
    };

    const handleOpen = (specialization: Specialization) => {
      setSpecializationName(specialization?.SpecializationName);
      setId(specialization?.Id);
      setIsActive(specialization?.IsActive);
      setCreatedDate(specialization?.CreateDate);
      setScore(specialization?.Score);
      handleOpenSpecializationDetails();
    }

    const handleDelete = () => {
      handleCloseSpecializationDetails();
      handleOpenDeleteSpecializationModal();
    };
    
    const handleUpdate = () => {
      handleCloseSpecializationDetails();
      handleOpenUpdateSpecializationModal();
    };

    return (
      <StyledContainer>
          <TotalWrapper>
              <span>Total</span>
              <TotalNumberStyle>{specialization?.Data?.length}</TotalNumberStyle>
          </TotalWrapper>
          {specialization?.Data && specialization?.Data?.length > 0 &&
              specialization?.Data?.map((data) => (
              <RoleWrapper onClick={() => handleOpen(data)} key={data?.Id}>
                  <div>
                      <RoleIconWrapper><RoleIcon /></RoleIconWrapper>
                      <RoleText>{data?.SpecializationName}</RoleText>
                      <Active>{data?.IsActive === true ? 'Active' : 'Disabled'}</Active>
                      <DateWrapper>{convertTimetoString(data?.CreateDate, 0)}</DateWrapper>
                  </div>
                  <ArrowIconWrapper>
                      <Arrow />
                  </ArrowIconWrapper>
              </RoleWrapper>
          ))}

          <SettingsModal 
              open={openSpecializationDetails}
              cancel={handleCloseSpecializationDetails}
              maxWidth='712px'
              header={specializationName && specializationName}
              content={<SpecializationDetails isActive={isActive} createdDate={convertTimetoString(createDate, 0)} score={score} />}
              card={<SpecializationOptions 
                  handleUpdate={handleUpdate} 
                  handleDelete={handleDelete}
              />}
          />

          <SettingsModal
              open={openUpdateSpecializationModal}
              cancel={handleCloseUpdateSpecializationModal}
              maxWidth='480px'
              header='Update Specialization'
              showrightIcon={false}
              content={<UpdateSpecialization 
                  specializationName={specializationName} 
                  handleClose={handleCloseUpdateSpecializationModal} 
                  id={id}
                  score={score}
              />}   
          />

          <SettingsModal
              open={openDeleteSpecializationModal}
              cancel={handleCloseDeleteSpecializationModal}
              maxWidth='536px'
              header='Delete Specialization'
              showrightIcon={false}
              content={<DeleteSpecialization 
                  id={id} 
                  handleClose={handleCloseDeleteSpecializationModal} 
                  specializationName={specializationName}
              />}   
          />
      </StyledContainer>     
    )
}

export default SpecializationContent;

const StyledContainer = styled('div')`
    margin-block: 3.8rem;
    margin-inline: 3.5rem;
`

const TotalNumberStyle = styled('span')`
    background-color: #F1F3F4;
    border-radius: 0.2rem;
    margin-inline-start: 0.4rem;
    padding-inline: 0.2rem;
`

const TotalWrapper = styled('div')`
    color: #4E5A62;
    font-weight: 500;
`

const RoleWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    border: 0.1rem solid #E1E1E1;
    margin-block: 0.6rem;
    padding-inline: 1.2rem;
    padding-block: 1.2rem;
    border-radius: 0.5rem;
    width: 100%;
    text-align: left;
    background-color: transparent;
`

const RoleIconWrapper = styled('span')`
    background-color: #FFF4DE;
    border-radius: 0.1rem;
    padding-inline: 0.4rem;
`

const RoleText = styled('span')`
    font-weight: 600;
    font-size: 16px;
    margin-inline: 0.8rem;
`

const Active = styled('span')`
    font-size: 14px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 0.5rem;
    color: #11643C;
`

const DateWrapper = styled('div')`
    margin-block-start: 0.8rem;
`

const ArrowIconWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
`